import React, { Component, Fragment } from 'react'

import Button from '../../components/Button/'
import { Cross, ChevronThinLeft } from '../Icons'
import Select from '../../components/Select/'
import CheckBox from '../../components/CheckBox/'
import Input from '../../components/Input/'
import {
  Container,
  Popup,
  Header,
  Title,
  Form,
  ButtonContainer,
  CloseButton,
  Cancel,
  IconContainer,
  Feedback,
  InputFeedback,
  FormTitle
} from './styles'
import { white, red, almostblack, gray, lightgray } from '../../styles/colors'

class FormPopup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fields: props.fields || [],
      saved: false,
      submitted: false
    }
  }

  componentDidMount() {
    const { fields } = this.state
    fields.map(field => {
      if (field.type === 'select') {
        field.value = field.options[0].value
      }
      return null
    })
    this.setState({ fields })
  }

  componentDidUpdate(prevProps) {
    if (this.props.clearForm) {
      if (this.props.data !== prevProps.data) {
        if (!this.props.error) {
          const { fields } = this.state
          if (!this.props.error) {
            this.setState({ submitted: false })
            fields.map(field => {
              if (field.type !== 'select') {
                field.value = ''
              }
              return null
            })
          }

          this.setState({ fields })
        }
      }
    }
  }

  handleChange(e) {
    const fields = this.state.fields
    const key = e.target.dataset.key

    if (fields[key].type === 'checkbox') {
      fields[key].value = !fields[key].value
    } else {
      fields[key].value = e.target.value
    }

    this.setState({
      fields: fields
    })
  }

  handleSubmit(event) {
    event.preventDefault()
    this.setState({ saved: true, submitted: true })
    const data = {}
    if (!this.props.doesntNeedBranches) {
      data.branches = []
    }
    this.state.fields.map(field => {
      if (field.type === 'checkbox' && field.value) {
        data.branches.push(field.name)
        return null
      } else {
        if (field.type !== 'checkbox') {
          data[field.name] = field.value !== '' ? field.value : null
        }
        return null
      }
    })

    if (this.props.id) {
      data.id = this.props.id
    }

    try {
      this.props.onSubmitForm({ variables: { data } }).then(result => {
        this.props.closePopup()
      })
    } catch (e) {
      console.error(e)
    }
  }

  render() {
    return (
      <Container>
        <Popup>
          <Cancel onClick={this.props.closePopup}>
            <IconContainer>
              <ChevronThinLeft size='' />
            </IconContainer>
            <span>Annuleren</span>
          </Cancel>

          <Header>
            <Title>{this.props.title}</Title>

            <CloseButton onClick={this.props.closePopup}>
              <Cross size='xlarge' />
            </CloseButton>
          </Header>

          <Form onSubmit={this.handleSubmit.bind(this)}>
            {this.state.fields.map((field, index) => {
              if (field.type === 'select') {
                return (
                  <Select
                    key={index}
                    dataKey={index}
                    value={field.value}
                    handleChange={this.handleChange.bind(this)}
                    name={field.name}
                    label={field.label}
                    options={field.options}
                  />
                )
              } else if (field.type === 'checkbox') {
                return (
                  <CheckBox
                    key={index}
                    dataKey={index}
                    value={field.value}
                    handleChange={this.handleChange.bind(this)}
                    name={field.name}
                  >
                    {field.label}
                  </CheckBox>
                )
              } else if (field.type === 'title') {
                return <FormTitle key={index}>{field.name}</FormTitle>
              } else {
                return (
                  <Fragment key={index}>
                    <Input
                      key={index}
                      dataKey={index}
                      value={field.value}
                      handleChange={this.handleChange.bind(this)}
                      name={field.name}
                      type={field.type}
                      label={field.label}
                      valid={this.state.submitted && field.required === 'required' ? field.value !== '' : true}
                    />
                    {this.state.submitted && field.required === 'required' ? (
                      <Fragment>
                        {field.value === '' ? (
                          <InputFeedback>Vul uw {field.label.toLowerCase()} in</InputFeedback>
                        ) : null}
                      </Fragment>
                    ) : null}
                  </Fragment>
                )
              }
            })}

            <ButtonContainer>
              <Button
                background={white}
                color={gray}
                border={lightgray}
                radius='true'
                hover={almostblack}
                onSubmit={this.props.closePopup}
                type='none'
              >
                Cancel
              </Button>

              <Button
                background={red}
                color={white}
                radius='true'
                hover={almostblack}
                onSubmit={this.handleSubmit.bind(this)}
                type='submit'
              >
                Opslaan
              </Button>
            </ButtonContainer>
            <Feedback saved={this.state.saved} error={this.props.error !== ''}>
              {this.props.loading && <span>Laden...</span>}
              {this.props.error && <span>{this.props.errorMessage}</span>}
              {this.props.data && <span>{this.props.succesMessage}</span>}
            </Feedback>
          </Form>
        </Popup>
      </Container>
    )
  }
}

export default FormPopup



// WEBPACK FOOTER //
// ./src/components/FormPopup/index.js